import { useMemo } from 'react';
import { zoomFactorValue } from '../../components/Solution/Preview.types';

export interface UseImageDimensionsProps {
  cardWidth: number;
  contenerHeight: number;
  contenerWidth: number;
  imageHeight: number;
  imageWidth: number;
  rotateAngle: number;
  zoomFactor: number;
}

export const useImageDimensions = ({
  cardWidth,
  contenerHeight,
  contenerWidth,
  imageHeight,
  imageWidth,
  rotateAngle,
  zoomFactor,
}: UseImageDimensionsProps) => {
  const isDisplayAngleHorizontal = Math.abs((rotateAngle - 90) % 180) === 0;
  const imageWidthAfterRotation = isDisplayAngleHorizontal ? imageHeight : imageWidth;
  const imageHeightAfterRotation = isDisplayAngleHorizontal ? imageWidth : imageHeight;
  const dimensionRatioAfterRotation =
    imageWidthAfterRotation && imageHeightAfterRotation ? imageWidthAfterRotation / imageHeightAfterRotation : 1;

  const displayWidth: number = useMemo(() => {
    switch (zoomFactor) {
      case zoomFactorValue.screenWidth:
        return contenerWidth;
      case zoomFactorValue.screenWidthAndHeight: {
        const tmpWidth = contenerWidth;
        if (tmpWidth / dimensionRatioAfterRotation <= contenerHeight) {
          return tmpWidth;
        }
        return contenerHeight * dimensionRatioAfterRotation;
      }

      default:
        return cardWidth * (isDisplayAngleHorizontal ? dimensionRatioAfterRotation : 1) * zoomFactor;
    }
  }, [zoomFactor, cardWidth, contenerWidth, contenerHeight, dimensionRatioAfterRotation, isDisplayAngleHorizontal]);

  const displayHeight = displayWidth / dimensionRatioAfterRotation;

  return {
    isDisplayAngleHorizontal,
    displayWidth: Math.round(displayWidth),
    displayHeight: Math.round(displayHeight),
  };
};
